module.exports = __webpack_public_path__ + "media/images/landing/crime/product-1-cf22aaee24aed665e8622f60e24c8ca9.png";